import React from "react";
import styled from "styled-components";
import { Dialog } from "@mui/material";
import { Text, Button } from "src/components";

import MeLogo from "src/img/new/me_logo.svg";

const StyledButton = styled(Button)`
    width: 100%;
    max-width: ${p => p.maxWidth || "8.75rem"};
    height: 2.345625rem;
    border-radius: 7px !important;
    border: ${p => p.border};
    background-color: ${p => p.backgroundColor};
    color: ${p => p.color};
    font-size: 0.875rem;
    line-height: 100%;
    margin: 0;
`;

const StyledText = styled(Text)`
    text-align: left;
    margin: ${p => p.margin};
    font-size: ${p => p.size || "1rem"};
`;

const PromptFrame = styled.div`
    width: 100%;
    max-height: inherit;
    display: flex;
    flex-direction: column;
`;

const PromptHeader = styled.header`
    min-height: 5.5rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1.25rem;
    padding: 1.25rem 3.75rem;
    background-color: #112970;
    box-sizing: border-box;

    img {
        display: block;
        max-width: 7rem;
        max-height: 3rem;
    }

    @media (max-width: 640px) {
        padding: 1.25rem;
    }
`;

const PromptBody = styled.div`
    width: 100%;
    min-height: 0;
    padding: 1.5rem 3.75rem;
    overflow-y: auto;
    box-sizing: border-box;

    @media (max-width: 640px) {
        padding: 1.5rem 1.25rem;
    }
`;

const PromptFooter = styled.footer`
    min-height: 5rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 1.25rem 3.75rem;
    border-top: 1px solid #e0e0e0;
    box-sizing: border-box;

    @media (max-width: 640px) {
        padding: 1.25rem;
    }
`;

const PromptTitle = styled(StyledText)`
    @media (max-width: 640px) {
        font-size: 2rem;
    }
`;

function ActivateBusinessActionPrompt(props) {
    const { showDialog, handleClose, confirmCallback, companyDetails, actionName } = props;

    // const lowercaseAction = actionName.toLowerCase();

    return (
        <Dialog open={showDialog} onClose={handleClose}
            maxWidth={false}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            PaperProps={{
                style: {
                    width: "95%",
                    maxWidth: "759px",
                    maxHeight: "88vh",
                    borderRadius: 15,
                    overflow: "hidden"
                },
            }}
        >
            <PromptFrame>
                <PromptHeader>
                    <img src={MeLogo} alt="Me" />
                    <StyledText size="20px" color="#FFF" margin="0">Business</StyledText>
                </PromptHeader>

                <PromptBody>
                    <PromptTitle weight="700" size="40px" margin="0 0 15px 0">
                        Activate Your Me Business Account
                    </PromptTitle>
                    <StyledText weight="700" size="16px" margin="0 0 15px 0" color="#612684">
                        Attention {companyDetails.companyName}
                    </StyledText>
                    <StyledText weight="700" size="16px" margin="0 0 15px 0">
                        Welcome aboard! Your account has now been upgraded from demo mode to an active Me Business account.
                    </StyledText>
                    <StyledText margin="0 0 15px 0">
                        To unlock full access to all features and start inviting your team or clients, please complete your account activation by finalising your payment for the selected user licenses.
                    </StyledText>
                    <StyledText margin="0 0 15px 0">
                        Click <strong>&apos;{actionName}&apos;</strong> below to securely add your payment method and activate your Me Business account today.
                    </StyledText>
                    <StyledText margin="0">
                        Once complete, you’ll have full access to your custom platform and can begin using all Me Business tools and features right away.
                    </StyledText>
                </PromptBody>

                <PromptFooter>
                    <StyledButton
                        maxWidth="140px"
                        backgroundColor="#171A22"
                        color="#FFF"
                        onClick={() => confirmCallback()}
                    >
                        Proceed
                    </StyledButton>
                </PromptFooter>
            </PromptFrame>
        </Dialog>
    );
}

export default ActivateBusinessActionPrompt;
